import React, { useEffect } from 'react'
import { useLocation } from 'react-router';

export default function ScrollToTopOnChange() {
  const location = useLocation() 
  useEffect(() => window.scrollTo(0,0), [location])

  return null
}